<template>
  <div class="row">
    <div class="col">
      <div class="pb-1">First bill purchase condition</div>
      <div class="d-flex flex-row">
        <div class="form-check form-check-inline pr-15">
          <input
            class="form-check-input mr-2"
            id="withPurchase"
            type="checkbox"
            v-model="form.isWithPurchase"
            :class="{
              'input--error': isSubmit && error.errorIsWithPurchase,
            }"
          />
          <div v-if="isSubmit && error.errorIsWithPurchase" class="text-error">
            {{ error.errorIsWithPurchase.message }}
          </div>
          <label class="form-check-label" for="withPurchase"
            >With purchase</label
          >
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input mr-2"
            id="withoutPurchase"
            type="checkbox"
            v-model="form.isWithoutPurchase"
            :class="{
              'input--error': isSubmit && error.errorIsWithoutPurchase,
            }"
          />
          <div
            v-if="isSubmit && error.errorIsWithoutPurchase"
            class="text-error"
          >
            {{ error.errorIsWithoutPurchase.message }}
          </div>
          <label class="form-check-label" for="withoutPurchase"
            >Without purchase</label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FirstBillPurchaseCondition",
  props: {
    error: {
      type: Object,
      default: () => {},
    },
    form: {
      type: Object,
      default: () => {},
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss" scoped>
.text-error {
  color: red;
  font-size: 12px;
}
</style>
